module.exports = __webpack_public_path__ + "static/media/tshirt.58f3548e.svg";